module.exports = __webpack_public_path__ + "static/media/apr.758dfb76.png";